import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'app-ui-card-kpi',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <article class="ui-card" [class]="cardClass()">
      @if (eyebrow()) {
        <p class="ui-card__eyebrow">{{ eyebrow() }}</p>
      }
      @if (title()) {
        @if (headingLevel() === 2) {
          <h2>{{ title() }}</h2>
        } @else {
          <h3>{{ title() }}</h3>
        }
      }
      @if (subtitle()) {
        <p class="ui-card__subtitle">{{ subtitle() }}</p>
      }
      @if (value()) {
        <p class="ui-card__value" [class.ui-card__value--acento]="kpiTone() === 'acento'">{{ value() }}</p>
      }
      <ng-content />
    </article>
  `,
  styles: [`
    :host { display: block; min-width: 0; }
    .ui-card { display: grid; gap: calc(var(--esp-interno) / 3); padding: var(--esp-tarjeta); border-radius: var(--radius); background: var(--surface); border: 1px solid transparent; box-shadow: var(--shadow); min-width: 0; }
    h2, h3, p { margin: 0; }
    h2, h3 { font-size: var(--t-h3); font-weight: 300; line-height: 1.25; color: var(--azul); overflow-wrap: anywhere; min-width: 0; }
    .ui-card--secundaria { border-radius: var(--radius-table); box-shadow: var(--shadow-sm); padding: calc(var(--esp-tarjeta) - 6px) calc(var(--esp-tarjeta) - 4px); }
    .ui-card--borde { border-color: var(--border); box-shadow: var(--shadow-none); }
    .ui-card--compacta { padding: calc(var(--esp-seccion) - 4px) calc(var(--esp-tarjeta) - 8px); }
    .ui-card--destacada { border: 2px solid var(--primary); box-shadow: var(--card-highlight-shadow); }
    .ui-card--sin-relleno { padding: 0; overflow: hidden; background: var(--surface); }
    .ui-card__eyebrow { margin: 0 0 calc(var(--esp-interno) - 4px); font-size: var(--t-cuerpo-chico); font-weight: 700; letter-spacing: 0.8px; text-transform: uppercase; color: var(--apagado); }
    .ui-card__subtitle { color: var(--muted); font-size: var(--t-cuerpo-chico); overflow-wrap: anywhere; min-width: 0; }
    .ui-card__value { margin-top: calc(var(--esp-interno) / 3); font-size: var(--t-cifra-kpi); font-weight: 300; color: var(--primary); line-height: 1.1; font-variant-numeric: tabular-nums; }
    .ui-card__value--acento { color: var(--apagado); }
  `],
})
export class UiCardKpiComponent {
  readonly title = input('');
  readonly subtitle = input('');
  readonly eyebrow = input('');
  readonly value = input('');
  readonly variant = input<'base' | 'secundaria' | 'borde' | 'compacta' | 'destacada' | 'sin-relleno'>('base');
  readonly kpiTone = input<'normal' | 'acento'>('normal');
  readonly headingLevel = input<2 | 3>(2);

  protected cardClass(): string {
    return `ui-card ui-card--${this.variant()}`;
  }
}
